import yup from '@/libs/yup';

export const projectFormV2Schema = yup.object({
    idn: yup.string().idn().required(),
    title: yup.string().required(),
    version: yup.string(),
    description: yup.string(),
    activate_from_module: yup.boolean().required(),
    registry_idn: yup
        .string()
        .nullable()
        .when('activate_from_module', {
            is: true,
            then: (schema) => schema.idn().required('Registry is required'),
            otherwise: (schema) => schema.notRequired()
        }),
    module_idn: yup
        .string()
        .nullable()
        .when('activate_from_module', {
            is: true,
            then: (schema) => schema.required('Module is required'),
            otherwise: (schema) => schema.notRequired()
        }),
    module_version: yup.string().nullable().version()
});
